__turbopack_context__.v({
  "close": "informativeBanner-module-scss-module__H7h98G__close",
  "content": "informativeBanner-module-scss-module__H7h98G__content",
  "cta": "informativeBanner-module-scss-module__H7h98G__cta",
  "dark": "informativeBanner-module-scss-module__H7h98G__dark",
  "fixed": "informativeBanner-module-scss-module__H7h98G__fixed",
  "icon": "informativeBanner-module-scss-module__H7h98G__icon",
  "informativeBanner": "informativeBanner-module-scss-module__H7h98G__informativeBanner",
  "items": "informativeBanner-module-scss-module__H7h98G__items",
  "primaryBlue": "informativeBanner-module-scss-module__H7h98G__primaryBlue",
  "sticky": "informativeBanner-module-scss-module__H7h98G__sticky",
  "text": "informativeBanner-module-scss-module__H7h98G__text",
});
